import { ProjectStatus, statusInFastFilter, StatusKey } from 'api-client';

export type StatusTableColumn = {
  label: string;
  align?: 'left' | 'center' | 'right';
  nowrap?: boolean;
  withRoiIrrHint?: boolean;
};

export type StatusTableConfig = {
  statuses: Array<ProjectStatus>;
  columns: Array<StatusTableColumn>;
  gridColumns: string;
  emptyText: string;
};

const DEFAULT_COLUMNS: Array<StatusTableColumn> = [
  { label: 'Проект' },
  { label: 'Сумма сбора' },
  { label: 'Прогноз взыскания' },
  { label: 'ROI / IRR', withRoiIrrHint: true },
  { label: 'Срок' },
  { label: '' },
  { label: '' },
];

const DEFAULT_GRID_COLUMNS = '1.9fr 1.35fr 1.25fr 1.1fr 0.6fr 2.1fr 1.5fr';

const PAID_COLUMNS: Array<StatusTableColumn> = [
  { label: 'Проект' },
  { label: 'Сумма сбора' },
  { label: 'Прогноз взыскания' },
  { label: 'ROI / IRR', withRoiIrrHint: true },
  { label: 'Факт. срок', nowrap: true },
  { label: 'Дата завершения' },
  { label: '' },
];

const PAID_GRID_COLUMNS = '1.9fr 1.3fr 1.2fr 1.1fr 0.8fr 1.1fr 2.3fr';

const CURRENT_COLUMNS: Array<StatusTableColumn> = [
  { label: 'Проект' },
  { label: 'Сумма сбора' },
  { label: 'Прогноз взыскания' },
  { label: 'ROI / IRR', withRoiIrrHint: true },
  { label: 'Срок' },
  { label: 'Старт проекта' },
  { label: 'Плановое завершение' },
  { label: '' },
];

const CURRENT_GRID_COLUMNS = '1.8fr 1.2fr 1.2fr 1fr 0.6fr 1fr 1.2fr 2.1fr';

const REFUNDED_COLUMNS: Array<StatusTableColumn> = [
  { label: 'Проект' },
  { label: 'Сумма сбора' },
  { label: 'Прогноз взыскания' },
  { label: 'ROI / IRR', withRoiIrrHint: true },
  { label: 'Срок' },
  { label: 'Старт проекта' },
  { label: 'Дата отмены' },
  { label: '' },
];

const REFUNDED_GRID_COLUMNS = '1.8fr 1.2fr 1.2fr 1fr 0.6fr 1fr 1.1fr 2.2fr';

const FUND_RAISING_COLUMNS: Array<StatusTableColumn> = [
  { label: 'Проект' },
  { label: 'Сумма сбора' },
  { label: 'Прогноз взыскания' },
  { label: 'План. ROI / IRR', nowrap: true, withRoiIrrHint: true },
  { label: 'План. срок', nowrap: true },
  { label: '' },
  { label: '' },
];

const FUND_RAISING_GRID_COLUMNS = '1.9fr 1.35fr 1.25fr 1.3fr 0.85fr 2.1fr 1.5fr';

const DEFAULT_EMPTY_TEXT = 'Проекты не найдены';

export const statusTables: Record<StatusKey, StatusTableConfig> = {
  Анонсирован: {
    statuses: statusInFastFilter['Анонсирован'],
    columns: DEFAULT_COLUMNS,
    gridColumns: DEFAULT_GRID_COLUMNS,
    emptyText: DEFAULT_EMPTY_TEXT,
  },
  'Сбор средств': {
    statuses: statusInFastFilter['Сбор средств'],
    columns: FUND_RAISING_COLUMNS,
    gridColumns: FUND_RAISING_GRID_COLUMNS,
    emptyText: DEFAULT_EMPTY_TEXT,
  },
  Текущий: {
    statuses: statusInFastFilter['Текущий'],
    columns: CURRENT_COLUMNS,
    gridColumns: CURRENT_GRID_COLUMNS,
    emptyText: DEFAULT_EMPTY_TEXT,
  },
  Завершен: {
    statuses: statusInFastFilter['Завершен'],
    columns: PAID_COLUMNS,
    gridColumns: PAID_GRID_COLUMNS,
    emptyText: DEFAULT_EMPTY_TEXT,
  },
  Отменен: {
    statuses: statusInFastFilter['Отменен'],
    columns: REFUNDED_COLUMNS,
    gridColumns: REFUNDED_GRID_COLUMNS,
    emptyText: DEFAULT_EMPTY_TEXT,
  },
};

export const DEFAULT_STATUS_KEY: StatusKey = 'Сбор средств';

export const getStatusKeyByStatuses = (statuses: Array<ProjectStatus>): StatusKey => {
  const key = (Object.keys(statusTables) as Array<StatusKey>).find((statusKey) =>
    statusTables[statusKey].statuses.every((status) => statuses.includes(status))
  );

  return key ?? DEFAULT_STATUS_KEY;
};
